export function stringIsPresent(thing) {
  return typeof thing === 'string' && thing !== ''
}

export function arrayIsPresent(thing) {
  return Array.isArray(thing) && thing.length > 0
}
